/****************************************/
var interior_design = {
  'content': {},
  'selected': 0,
  'quotes': [
    {'quote': "Ebba has a fantastic eye for colour, tone and light that ensured we could create unique individual spaces whilst at the same time she was considerate of ensuring that all rooms both in the new build and old spoke to each other", 'credit': "Client Testimonial 2013"},
    {'quote': "We had pretty strong notions of what feel we were looking for but found it difficult to specify what that meant. Ebba was able to understand our needs and put concrete ideas behind it. Ultimately we could not be happier with the house that we together have created", 'credit': "Client Testimonial 2013"},
    {'quote': "Beautiful colours, textures and great fresh ideas. Love my home", 'credit': "Client Testimonial 2015"},
    {'quote': "The first thing people always comment on are the wonderful colours in my home & the second thing is how it feels modern, yet warm and personal. While I know Ebba had everything to do with it, people always say it’s very “me”, witch is a perfect outcome when you are doing your home", 'credit': "Client Testimonial 2012"},
    {'quote': "Ebba really goes all-in to supply fantastic designs. Her extraordinary feeling for coulors and light makes her designs unique-modern with a classic touch", 'credit': "Client Testimonial 2011"},
    {'quote': "Ebba has a unique vision....not just bespoke to the client but bespoke to the market place. truly something different and inventive", 'credit': "Client Testimonial 2011"},
    {'quote': "Ebba understood exactly what we wanted and made creative use out of a quirky soho space. 3 years on and we are still \'into\' our office", 'credit': "Client Testimonial 2011"},
    {'quote': "Ebba has given us light, texture & elegant storage. It feels like home", 'credit': "Client Testimonial 2010"},
    {'quote': "Ebba and the Sigmar team has created a brought our turn of century house into a home of today: in keeping the typical details of the old house yet giving it a new and suttle modern feeling by the coloring, lighting and furniture.Every room has its own feeling, yet the whole house is well connected by color, light and texture and ends up giving a lovely sense of harmony and warmth.", 'credit':"Client Testimonial 2014"}
   ],
  'quote_number': 0,
  'quote_timer': 5
}
/****************************************/


/****************************************/
function interiorDesignLoad(object){
  
  /* -- Load Content -- */
  if(object.type == "load"){
    
    storage = {
      'count': 0,
      'description': "",
      'images': []
    };

    if($(".interiors>.slides").attr("data-type") == "legacy"){
      if($(".invisible_content").length && $(".invisible_content>table").length){
         $(".invisible_content>table>tbody>tr").each(function(){
           if(storage.count == 0){
             storage.description = $(this).find("td").html();
           }else{
             storage.images.push($(this).find("td>img").attr("src"));
           }
           storage.count++;
         });
      }

      if(storage.count && storage.images.length){
        interiorDesignLoad({'type': "setup", 'content': storage});
      } 
    }else{
      storage.count = $(".interiors>.slides>ul>li").length;
      storage.description = $(".invisible_content").html();
      interiorDesignLoad({'type': "setup", 'content': storage});
    }
    
  }
  
  /* -- Setup Content -- */
  if(object.type == "setup"){
    
    storage = {
      'quotes': "",
      'description': "",
      'images': "",
      'pickers': ""
    };
    
    /* -- Store Object -- */
    interior_design.content = object.content;
    
    /* -- Build Template -- */
    if(interior_design.content.description != ""){
      $(".interiors>.column>.inner>.description").html(interior_design.content.description);
    }else{
      $(".interiors>.column>.inner>.description").remove();
      $(".interiors>.column>.inner>.divid.x2").remove();
    }
    
    /* -- Quote(s) -- */
    if(interior_design.quotes.length > 0){
      interior_design.quotes.sort(function(a, b){return 0.5 - Math.random()});
      for(var i = 0; i < interior_design.quotes.length; i++){
        storage.quotes += "<div>";
          storage.quotes += "<p>&ldquo;"+interior_design.quotes[i].quote+"&rdquo;</p>";
          storage.quotes += "<p>"+interior_design.quotes[i].credit+"</p>";
        storage.quotes += "</div>";
      }
      $(".interiors>.column>.inner>.quotes").html(storage.quotes);
    }else{
      $(".interiors>.column>.inner>.quotes").remove();
    }

    console.log($(".interiors>.slides").attr("data-type"));
    
    /* -- Image(s) & Navigation -- */
    if(
      $(".interiors>.slides").attr("data-type") == "legacy" &&
      interior_design.content.images.length > 0
    ){
      
      storage.images += "<ul>";
      for(var i = 0; i < interior_design.content.images.length; i++){
      	storage.images += "<li>";
          storage.images += "<img src='"+interior_design.content.images[i]+"' alt='Sigmar London - Interior Design: "+$(".column>.inner>h1").html()+" Image "+(i+1)+"'>";
        storage.images += "</li>";
        storage.pickers += "<div class='picker' data-control='selected' data-selected='"+(i)+"'></div>";
      }
      storage.images += "</ul>";
      $(".interiors>.slides").html(storage.images);
      $(".interiors>.controls>.pickers").html(storage.pickers);

    }else if(
      $(".interiors>.slides").attr("data-type") == "meta" &&
      object.content.count > 0
    ){
      for(var i = 0; i < interior_design.content.count; i++){
        storage.pickers += "<div class='picker' data-control='selected' data-selected='"+(i)+"'></div>";
      }
      $(".interiors>.controls>.pickers").html(storage.pickers);
    }else{
      $(".interiors>.slides, .interiors>.pickers").remove();
    }

    /* -- Control(s) -- */
    $(".interiors>.column>.inner>.close, .interiors>.details, .interiors>.controls>.arrows.prev, .interiors>.controls>.arrows.next, .interiors>.controls>.pickers>.picker").click(function(){
      interiorDesignLoad({'type': "controls", 'action': $(this).attr("data-control"), 'selected': $(this).attr("data-selected")  });
    });
    
    /* -- Quotes Timer Trigger -- */
    interiorDesignLoad({'type': "quotes"});
    
    /* -- Display -- */
    interiorDesignLoad({'type': "display"});
    
  }
  
  /* -- Controls -- */
  if(object.type == "controls"){
    
    /* -- Close -- */
    if(object.action == "close"){
      $(".interiors>.column").addClass("close");
      $(".interiors>.details").addClass("open");
    }
    
    /* -- Open -- */
    if(object.action == "open"){
      $(".interiors>.column").removeClass("close");
      $(".interiors>.details").removeClass("open");
    }
   
    /* -- Next -- */
    if(object.action == "next"){
      interior_design.selected++;
    }
    
    /* -- Prev -- */
    if(object.action == "prev"){
      interior_design.selected--;
    }
    
    /* -- Selected -- */
    if(object.action == "selected"){
      interior_design.selected = parseInt(object.selected);
    }
    
    /* -- Display -- */
    interiorDesignLoad({'type': "display"});
    
  }
  
  /* -- Quotes -- */
  if(object.type == "quotes"){
    setTimeout(function(){
      $(".interiors>.column>.inner>.quotes>div:nth-child("+(interior_design.quote_number+1)+")").animate({'opacity': 0}, 500);
      if(interior_design.quote_number < ($(".interiors>.column>.inner>.quotes>div").length-1)){
        interior_design.quote_number++;
      }else{
        interior_design.quote_number = 0;
      }
      setTimeout(function(){
        $(".interiors>.column>.inner>.quotes>div").css({'display': "none"});
        $(".interiors>.column>.inner>.quotes>div:nth-child("+(interior_design.quote_number+1)+")").css({'display': "block", 'opacity': 0}).animate({'opacity': 1}, 500);
      	interiorDesignLoad({'type': "quotes"});
      }, 500);
    }, interior_design.quote_timer * 1000);
  }
  
  /* -- Display -- */
  if(object.type == "display"){
    
    /* -- Arrow(s) -- */
    $(".interiors>.controls>.arrows").css({'display': "block"});
    if(interior_design.selected == 0){
      $(".interiors>.controls>.arrows.prev").css({'display': "none"});
    }else if(interior_design.selected >= ($(".interiors>.slides>ul>li").length-1)){
      $(".interiors>.controls>.arrows.next").css({'display': "none"});
    }
    
    /* -- Pickers -- */
    $(".interiors>.controls>.pickers>.picker").removeClass("selected");
    $(".interiors>.controls>.pickers>.picker:nth-child("+(interior_design.selected+1)+")").addClass("selected");
    
    /* -- Page Display -- */
    if(environment_array.screen.w >= 850){
      $(".interiors>.slides, .interiors>.controls").css({'height': (environment_array.screen.h-( $(".site-header").height()+100 )) });
    }else{
      $(".interiors>.slides, .interiors>.controls").css({'height': (environment_array.screen.h-( $(".site-header").height()+50 )) });
    }
    $(".interiors>.slides>ul>li").css({'width': environment_array.screen.w });
    $(".interiors>.controls>.pickers").css({'margin-left': -($(".interiors>.controls>.pickers").width()/2) })
  
    /* -- Slide Positions -- */
    $(".interiors>.slides>ul").css({'margin-left': -( $(".interiors>.slides").width()*interior_design.selected ) })
    
    /* -- Image Poistion -- */
    $(".interiors>.slides>ul>li").each(function(){
      $(this).css(
        {
          'padding-left': ((environment_array.screen.w - $(this).find("img").width())/2),
          'padding-top': (($(this).parent().height() - $(this).find("img").height())/2)
        }
      );
    });
    
  }
  
}
/****************************************/

/****************************************/
$(window).resize(function() {
  
  /* -- Interior Responsive -- */
  interiorDesignLoad({'type': "display"});
  
});
/****************************************/

/****************************************/
$(window).bind("load", function() {
  setTimeout(function() {
    
    /* -- Interiors Setup -- */
    interiorDesignLoad({'type': "load"});
    
  }, 100);
});
/****************************************/